import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FJUtil from '../../../util/FJUtil';
import useIsInViewport from '../../../hooks/useIsInViewPort';
const FJImg = props => {
    const { src, srcSet, className, style, alt, loading = 'lazy', onLoad, onError, setIsLoaded } = props;
    const [stateSrc, setStateSrc] = useState(srcSet);
    const [imgRef, isVisible] = useIsInViewport();

    useEffect(() => {
        setStateSrc(srcSet);
    }, [src, srcSet]);
    useEffect(() => {
        if (!imgRef.current) return;
        imgRef.current.src = stateSrc;
        return () => {
            FJUtil.releaseImageMemory(imgRef.current);
        };
    }, [stateSrc, imgRef]);
    useEffect(() => {
        if (!imgRef.current) return;
        if (isVisible) {
            imgRef.current.src = stateSrc;
            setIsLoaded(false);
        } else {
            FJUtil.releaseImageMemory(imgRef.current);
        }
    }, [isVisible, stateSrc, imgRef, setIsLoaded]);
    const _onLoad = e => {
        onLoad && onLoad(e);
    };
    const _onError = e => {
        if (stateSrc === srcSet) {
            setStateSrc(src);
            return;
        }
        onError && onError(e);
    };
    return (
        <img
            ref={imgRef}
            src={stateSrc}
            className={className}
            style={style}
            alt={alt}
            loading={loading}
            onLoad={_onLoad}
            onError={_onError}
        />
    );
};
FJImg.propTypes = {
    src: PropTypes.string,
    srcSet: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    alt: PropTypes.string,
    loading: PropTypes.string,
    onLoad: PropTypes.func,
    onError: PropTypes.func,
    setIsLoaded: PropTypes.func,
};
export default FJImg;
